class DisplayUtil {
  formatNumber(value) {
    if (value === null || value === undefined || value === '') {
      return value;
    }

    let number = Number(value);
    return isNaN(number) ? value : number.toLocaleString();
  }

  scrollToRef(ref) {
    let header = document.getElementsByTagName('header')[0];
    let headerHeight = header.getBoundingClientRect().height;

    let topOfEle = ref.current
      .getBoundingClientRect().y;

    window.scroll({
      top: topOfEle + window.scrollY - headerHeight,
      behavior: 'smooth'
    });
  }
}

export default new DisplayUtil();
